import { useField, useFormikContext } from 'formik';

import {
  AUDIENCE_SOURCE_OPTIONS,
  DemographicFormData,
  getValuesForAudienceSourceChange,
} from '../../../util/demographics';
import { useHasRole } from 'hooks/users';

import FormGroup from 'components/common/forms/FormGroup';
import FormSearchSelectInputV2 from '../../common/forms/FormSearchSelectInputV2';

import { BuildYourAudienceCard } from './BuildYourAudienceCard/BuildYourAudienceCard';
import { DefineAudienceCard } from './DefineAudience/DefineAudienceCard';
import { InboundCensusOptions } from './InboundCensusOptions/InboundCensusOptions';
import { PartnerPanelProvider } from './PartnerPanelProvider/PartnerPanelProvider';
import { CountrySelect } from './CountrySelect/CountrySelect';

export const VALUE_FOR_US_COUNTRY = 'USA';

export const AudienceProfile = () => {
  const isAdmin = useHasRole('admin');
  const { setValues, values } = useFormikContext<DemographicFormData>();

  const [{ value: audienceSource }] = useField<
    DemographicFormData['audienceProfile']['audienceSource']
  >('audienceProfile.audienceSource');
  const [{ value: panelProvider }] = useField<
    DemographicFormData['audienceProfile']['panelProvider']
  >('audienceProfile.panelProvider');
  const [{ value: selectedCountry }] =
    useField<DemographicFormData['selectedCountry']>('selectedCountry');

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <p className="text-gray-d-700">
          Use our integrated audience that reaches millions of potential
          respondents, or send the survey to your own audience.
        </p>
      </div>

      <div className="grid grid-cols-[300px_1fr]">
        <div>Select Source</div>
        <FormSearchSelectInputV2
          name="audienceProfile.audienceSource"
          onChange={(value) => {
            if (!value) {
              return;
            }
            setValues(
              getValuesForAudienceSourceChange({
                formData: values,
                newAudienceSource: value.value,
              }),
            );
          }}
          options={AUDIENCE_SOURCE_OPTIONS}
        />
      </div>

      {audienceSource === 'sample-provider' && (
        <>
          {isAdmin && (
            <div className="grid grid-cols-[300px_1fr]">
              <div>Select Sample Provider</div>
              <FormGroup>
                <PartnerPanelProvider />
              </FormGroup>
            </div>
          )}

          <div className="grid grid-cols-[300px_1fr]">
            <div>Select Country</div>
            <FormGroup>
              <CountrySelect />
            </FormGroup>
          </div>

          {panelProvider === 'LUCID' &&
            selectedCountry === VALUE_FOR_US_COUNTRY && (
              <div className="grid grid-cols-[300px_1fr]">
                <div>Inbound Census Options</div>
                <FormGroup>
                  <InboundCensusOptions />
                </FormGroup>
              </div>
            )}
        </>
      )}

      <div className="border-t border-gray-d-200 pt-6 space-y-6">
        <DefineAudienceCard
          audienceSource={audienceSource}
          panelProvider={panelProvider}
        />
        <BuildYourAudienceCard />
      </div>
    </div>
  );
};
